import React from "react";
import {
  Button as MUIButton,
  CircularProgress,
  makeStyles
} from "@material-ui/core";
import clsx from "clsx";

const useStyles = makeStyles(theme => ({
  progressColorSecondary: {
    color: "#fff"
  }
}));

const Button = props => {
  const { loading, children, color, progressSize = 24, ...restProps } = props;

  // General
  const classes = useStyles();

  return (
    <MUIButton color={color} {...restProps}>
      {!loading && children}
      {loading && (
        <CircularProgress
          size={progressSize}
          color={color === "primary" ? "secondary" : "primary"}
          className={clsx(
            color === "primary" && classes.progressColorSecondary
          )}
        />
      )}
    </MUIButton>
  );
};

export default Button;
